import { useRecoilState, useResetRecoilState } from 'recoil';

import { campaignOptionSelectSheet, visibleForOptionSelectSheet } from '@/store';
import { Campaign } from '@/apis';

export function useOptionSelectSheet() {
  const [_1, setVisible] = useRecoilState(visibleForOptionSelectSheet);
  const [_2, setProduct] = useRecoilState(campaignOptionSelectSheet);

  const resetProduct = useResetRecoilState(campaignOptionSelectSheet);

  function open(campaign: Campaign) {
    resetProduct();
    setProduct(campaign);
    setVisible(true);
  }

  function close() {
    setVisible(false);
  }

  return { open, close };
}
